import React from "react"

import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"

import NewVoucherAttachment from "./NewVoucherAttachment"
import NewVoucherHeader from "./NewVoucerHeader"
import NewVoucherRows from "./NewVoucherRows"
import NewVoucherExtras from "./NewVoucherExtras"
import NewVoucherButtons from "./NewVoucherButtons"

const NewVoucher = (props) => {
  return (
    <Container maxWidth="xl">
      <Grid container spacing={4}>
        <Grid item lg={12} xs={12}>
          <NewVoucherAttachment />
        </Grid>
        <Grid item lg={12} xs={12}>
          <NewVoucherHeader />
        </Grid>
        <Grid item lg={12} xs={12}>
          <NewVoucherRows />
        </Grid>
        <Grid item lg={12} xs={12}>
          <NewVoucherExtras />
        </Grid>
        <Grid item lg={12} xs={12}>
          <NewVoucherButtons />
        </Grid>
      </Grid>
    </Container>
  )
}

export default NewVoucher
